import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "./use_debounce_controller";

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["input", "spinner"];

  // see useDebounce hook
  static debounces = ["submit"];

  initialize() {
    super.initialize();
    // need to debounce here instead of in connect because
    // data-turbo-permanent causes connect to happen multiple times
    // and the debounces stack up
    useDebounce(this, { wait: 250 });
  }

  connect() {
    // handle the scenario where the input is focused after the search page loads
    if (this.inputTarget.value.trim() !== "") {
      this.inputTarget.focus();
      this.inputTarget.setSelectionRange(
        this.inputTarget.value.length,
        this.inputTarget.value.length,
      );
    }
  }

  submit() {
    const form = this.inputTarget.form;
    form.requestSubmit();
  }

  displaySpinner() {
    console.log("Displaying spinner");
    if (this.spinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }
  }

  hideSpinner() {
    if (this.spinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }
}
